export const INITIALIZE_PREFERENCES_DICT = 'preferences/INITIALIZE_PREFERENCES_DICT';
export const UPDATE_PREFERENCES_DICT = 'preferences/UPDATE_PREFERENCES_DICT';
